import { ActionRef } from 'further-types/lp/action';
import {
  createIncomeOrExpenseViewRoute,
  createLpInvestmentViewRoute,
  createLpRealisationViewRoute,
  createLpCapitalActionEditRoute,
  createManualActionEditRoute,
} from 'adminConstants/routes';

const getActionLink = (
  actionRef: ActionRef,
  actionId: string,
  incomeOrExpenseGroupId?: string,
): string | null => {
  switch (actionRef) {
    case ActionRef.IncomeOrExpense:
      return incomeOrExpenseGroupId
        ? createIncomeOrExpenseViewRoute(incomeOrExpenseGroupId)
        : null;
    case ActionRef.Investment:
      return createLpInvestmentViewRoute(actionId);
    case ActionRef.Realisation:
      return createLpRealisationViewRoute(actionId);
    case ActionRef.CapitalAction:
      return createLpCapitalActionEditRoute(actionId);
    case ActionRef.ManualAction:
      return createManualActionEditRoute(actionId);
    default:
      return null;
  }
};

export default getActionLink;
